import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import RoundedButton from '@componentsV2/buttons/RoundedButton';
import WebImg from '@components/common/WebpImg';
import { PlayIcon } from '@components/icons';
import Colors from 'styles/colors';
import ROUTES from 'seller/routing';
import { getPostContentPictureByPostId } from 'seller/pages/homepage-v2/img/learn-more-posts';
import StarCheckIcon from 'seller/pages/homepage-v2/img/common/star_checkbox.svg';

const UnderHeaderBlock = ({ title, description, getRegistrationButton }) => {
  const playButtonContent = (
    <div className="flex items-center">
      <PlayIcon fill={Colors.green.emerald} width="15px" height="18px" className="mr-3" />
      <span className="">Watch Demo</span>
    </div>
  );
  return (
    <div className="w-full flex-grow xl:grid grid-cols-2 py-6 xl:py-15 gap-6 xxl:gap-16 px-4 xl:px-0 text-gray-darkest max_w_1116px xxl:max_w_1404px xxxl:max_w_1596px">
      <div className="flex flex-col justify-center items-start">
        <div className="font_35px xl:font_60px font-bold">{title}</div>
        <div className="mt-4 xl:text-xl xxl:text-2xl font-light mb-6">{description}</div>
        <div className="hidden xl:flex flex-col gap-4 mb-6">
          <div className="flex items-center gap-2">
            <img src={StarCheckIcon} alt="star-checkbox" />
            <p>Real-time profit per SKU (including refunds and PPC).</p>
          </div>
          <div className="flex items-center gap-2">
            <img src={StarCheckIcon} alt="star-checkbox" />
            <p>Track true ROI by product, ad, or channel.</p>
          </div>
          <div className="flex items-center gap-2">
            <img src={StarCheckIcon} alt="star-checkbox" />
            <p>See all your metrics in one place across multiple brands and products.</p>
          </div>
          <div className="flex items-center gap-2">
            <img src={StarCheckIcon} alt="star-checkbox" />
            <p>Ideal for Agencies and Ecommerce Aggregators.</p>
          </div>
        </div>
        <div className="flex justify-center xl:justify-start gap-3 w-full">
          {getRegistrationButton()}
          <RoundedButton
            text={playButtonContent}
            outlined
            onClick={() => {
              window.location.href = ROUTES.demo;
            }}
            className="hidden"
          />
        </div>
      </div>
      <div className="px-4 xl:px-8 py-8 xl:py-16">
        <WebImg
          {...getPostContentPictureByPostId('sellermetrix')}
          alt="worker-laptop"
          imgClassName="w-full"
        />
      </div>
    </div>
  );
};

UnderHeaderBlock.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  description: PropTypes.string.isRequired,
  getRegistrationButton: PropTypes.element
};

UnderHeaderBlock.defaultProps = {
  getRegistrationButton: () => (
    <Link to={ROUTES.registration}>
      <RoundedButton text="Start for Free" />
    </Link>
  )
};

export default UnderHeaderBlock;
